import { render, staticRenderFns } from "./VariableSelector.vue?vue&type=template&id=70a721cc&scoped=true"
import script from "./VariableSelector.vue?vue&type=script&lang=js"
export * from "./VariableSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a721cc",
  null
  
)

export default component.exports